import request from '@/utils/request';
import { newHost } from '@/global-config';

/* 打款单列表查询 */
export function getListPayBill(data) {
  return request({
    url: '/payBill/listPayBill',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 打款单导出 */
export function downloadPayBill(data) {
  return request({
    url: '/payBill/download',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 获取电子回单 */
export function getReceipt(data) {
  return request({
    url: '/electronicReceipt/getElectronicReceipt',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 电子回单列表查询 */
export function getReceiptList(data) {
  return request({
    url: '/electronicReceipt/listElectronicReceipt',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 更新下载状态 */
export function updateDownloadStatus(data) {
  return request({
    url: '/electronicReceipt/updateStatus',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 电子回单下载 */
export function downloadReceipt(data) {
  return request({
    url: '/electronicReceipt/download',
    method: 'post',
    data,
    baseURL: newHost,
  });
}
